import { render, staticRenderFns } from "./BfAccountOperator.vue?vue&type=template&id=34897380&scoped=true"
import script from "./BfAccountOperator.vue?vue&type=script&lang=js"
export * from "./BfAccountOperator.vue?vue&type=script&lang=js"
import style0 from "./BfAccountOperator.vue?vue&type=style&index=0&id=34897380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34897380",
  null
  
)

export default component.exports